// Compute the next rank for a (work_list_type, is_priority) worklist group.
// Uses max(rank) + 1 rather than length + 1 — the latter produces duplicates
// whenever the group has a gap in its rank sequence (CPRD-4793).
export const nextRankForGroup = (
  worklists,
  workListType,
  isPriority,
  excludeWorkListId = null
) => {
  let max = 0;
  for (const w of worklists) {
    if (w.work_list_type !== workListType) continue;
    if (w.is_priority !== isPriority) continue;
    if (excludeWorkListId != null && w.work_list_id === excludeWorkListId) continue;
    if (typeof w.rank === 'number' && w.rank > max) max = w.rank;
  }
  return max + 1;
};
